export default "__VITE_ASSET__K9dNCtzs__"